webpackJsonp([35],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTranslations = setTranslations;
exports.getTranslations = getTranslations;
var translations = {};

function setTranslations(t) {
    Object.assign(translations, t);
}

function getTranslations() {
    return translations;
}

/***/ }),

/***/ 1852:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1853);


/***/ }),

/***/ 1853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactIntl = __webpack_require__(5);

var _nl = __webpack_require__(1854);

var _nl2 = _interopRequireDefault(_nl);

var _localeData = __webpack_require__(139);

var _nl3 = __webpack_require__(1855);

var _nl4 = _interopRequireDefault(_nl3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _localeData.setTranslations)(_nl4.default);
(0, _reactIntl.addLocaleData)(_nl2.default);

/***/ }),

/***/ 1854:
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.nl=n())}(this,function(){"use strict";return[{locale:"nl",pluralRuleFunction:function(e,n){var a=!String(e).split(".")[1];return n?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"jaar",relative:{0:"dit jaar",1:"volgend jaar","-1":"vorig jaar"},relativeTime:{future:{one:"over {0} jaar",other:"over {0} jaar"},past:{one:"{0} jaar geleden",other:"{0} jaar geleden"}}},"year-short":{displayName:"jr",relative:{0:"dit jaar",1:"volgend jaar","-1":"vorig jaar"},relativeTime:{future:{one:"over {0} jaar",other:"over {0} jaar"},past:{one:"{0} jaar geleden",other:"{0} jaar geleden"}}},month:{displayName:"maand",relative:{0:"deze maand",1:"volgende maand","-1":"vorige maand"},relativeTime:{future:{one:"over {0} maand",other:"over {0} maanden"},past:{one:"{0} maand geleden",other:"{0} maanden geleden"}}},"month-short":{displayName:"mnd",relative:{0:"deze maand",1:"volgende maand","-1":"vorige maand"},relativeTime:{future:{one:"over {0} maand",other:"over {0} maanden"},past:{one:"{0} maand geleden",other:"{0} maanden geleden"}}},day:{displayName:"dag",relative:{0:"vandaag",1:"morgen",2:"overmorgen","-2":"eergisteren","-1":"gisteren"},relativeTime:{future:{one:"over {0} dag",other:"over {0} dagen"},past:{one:"{0} dag geleden",other:"{0} dagen geleden"}}},"day-short":{displayName:"dag",relative:{0:"vandaag",1:"morgen",2:"overmorgen","-2":"eergisteren","-1":"gisteren"},relativeTime:{future:{one:"over {0} dag",other:"over {0} dgn"},past:{one:"{0} dag geleden",other:"{0} dgn geleden"}}},hour:{displayName:"uur",relative:{0:"binnen een uur"},relativeTime:{future:{one:"over {0} uur",other:"over {0} uur"},past:{one:"{0} uur geleden",other:"{0} uur geleden"}}},"hour-short":{displayName:"uur",relative:{0:"binnen een uur"},relativeTime:{future:{one:"over {0} uur",other:"over {0} uur"},past:{one:"{0} uur geleden",other:"{0} uur geleden"}}},minute:{displayName:"minuut",relative:{0:"binnen een minuut"},relativeTime:{future:{one:"over {0} minuut",other:"over {0} minuten"},past:{one:"{0} minuut geleden",other:"{0} minuten geleden"}}},"minute-short":{displayName:"min",relative:{0:"binnen een minuut"},relativeTime:{future:{one:"over {0} min.",other:"over {0} min."},past:{one:"{0} min. geleden",other:"{0} min. geleden"}}},second:{displayName:"seconde",relative:{0:"nu"},relativeTime:{future:{one:"over {0} seconde",other:"over {0} seconden"},past:{one:"{0} seconde geleden",other:"{0} seconden geleden"}}},"second-short":{displayName:"sec",relative:{0:"nu"},relativeTime:{future:{one:"over {0} sec.",other:"over {0} sec."},past:{one:"{0} sec. geleden",other:"{0} sec. geleden"}}}}},{locale:"nl-AW",parentLocale:"nl"},{locale:"nl-BE",parentLocale:"nl"},{locale:"nl-BQ",parentLocale:"nl"},{locale:"nl-CW",parentLocale:"nl"},{locale:"nl-SR",parentLocale:"nl"},{locale:"nl-SX",parentLocale:"nl"}]});


/***/ }),

/***/ 1855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nl = __webpack_require__(1856);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _nl2.default;

/***/ }),

/***/ 1856:
/***/ (function(module, exports) {

module.exports = {"1-to-1 Projects":"1-op-1 projecten","99nonprofits":"99nonprofits","API integrations":"API integraties","About":"Info","Account settings":"Account instellingen","Affiliates":"Affiliaties","Agencies":"Agencies","Become a designer":"Word een designer","Blog":"Blog","Book cover design":"Boekomslag ontwerp","Brand guide":"Merkgids","Browse all categories":"Blader door alle categorieën","Browse categories":"Blader door categorieën","Browse contests":"Wedstrijden doorbladeren","Business card":"Visitekaartje","Careers":"Vacatures","Categories":"Categorieën","Community":"Community","Company":"Bedrijf","Contact":"Contact","Contests":"Wedstrijden","Credits":"Credits","Design consultation":" ontwerpconsultatie","Design contests":"Ontwerpwedstrijden","Design services":"Ontwerp diensten","Designer resources":"Designer hulpmiddelen","Designers":"Designers","Discover":"Ontdek","Discover inspiration":"Ontdek inspiratie","Earnings":"Inkomsten","Featured partners":"Aanbevolen partners","Find a designer":"Vind een designer","Forum":"Forum","Get a design":"Ontvang een ontwerp","Getting started":"Aan de slag","Help":"Help","Help Center":"Helpcentrum","Home":"Home","How it works":"Hoe het werkt","Imprint":"Impressum","In the media":"In de media","Log in":"Inloggen","Log out":"Uitloggen","Logo design":"Logo ontwerp","Logo ideas":"Logo-ideeën","Mark all as read":"Alles als gelezen markeren","NDAs":"Geheimhoudingsovereenkomst","Notifications":"Meldingen","Packaging design":"Verpakking ontwerp","Press releases":"Persberichten","Pricing":"Prijzen","Privacy":"Privacy","Private messages":"Private messages","Profile":"Profiel","Projects":"Projecten","Recent winners":"Recente winnaars","Resources":"Bronnen","See all messages":"Bekijk alle berichten","See all notifications":"Alle meldingen bekijken","Settings":"Instellingen","Support":"Klantenservice ","T-shirt design":"T-shirt design","T-shirt ideas":"T-shirt-ideeën","Team":"Team","Terms":"Voorwaarden","Testimonials":"Testimonials","Transactions":"Transacties","Web page design":"Webdesign","Your clients":"Jouw klanten","Your work":"Je werk","{lang}":"{lang}","{phone}":"{phone}","© 99designs":"© 99designs","An error occured and we were unable to load your messages.":"Er is een fout opgetreden, we hebben je berichten niet kunnen laden.","Enable browser notificatons?":"Browser-notificaties toestaan?","Get updates on your device, even when 99designs is closed.":"Ontvang updates op jouw apparaat, ook wanneer 99designs niet geopend is.","Messages":"Berichten","No notifications found.":"Geen meldingen gevonden.","No thanks":"Nee bedankt","notification.body":"Top, notificaties zijn ingeschakeld! Notificaties aanpassen in jouw accountinstellingen.","notification.title":"Een notificatie van 99designs.","Please log in to view your messages":"Log in om je berichten te lezen","Find a designer and message them directly from their profile.":"Vind een ontwerper en stuur ze een bericht vanaf hun profielpagina.","Unable to load messages":"Het is niet mogelijk om berichten te laden","When you receive new messages, you will see them here.":"Wanneer je nieuwe berichten ontvangt, zal je deze hier terugvinden.","Yes please":"Ja graag","You have no private messages":"Je hebt geen privé berichten"}

/***/ })

},[1852]);


// WEBPACK FOOTER //
// locale-data/nl-e20a49ce58744caa0af4.js